<template>
  <div id="mobileGnb" class="navbar navbar-white">
    <div class="navbar-header">
      <!-- 메뉴 열기 버튼 -->
      <button v-show="!menuActive" type="button" class="navbar-toggle collapsed" aria-controls="mobileNav" data-target="#mobileNav" data-toggle="collapse">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span> <span class="icon-bar"></span>
      </button>
      <!-- 메뉴 닫기 버튼 -->
      <button v-show="menuActive" type="button" class="navbar-toggle close"
              aria-controls="mobileNa" data-target="#mobileNav" data-toggle="collapse">
        <span aria-hidden="true">×</span>
      </button>
      <router-link to="/admin" class="navbar-brand">
        <img src="~@/assets/svg/logo/logo-biz-admin.svg" class="img-responsive" alt="Bizhaezoom Logo" @click="close()">
      </router-link>
    </div>
    <!-- 메뉴 -->
    <nav id="mobileNav" class="navbar-collapse collapse" aria-expanded="true">
      <ul v-if="menuList.length > 0" class="nav navbar-nav">
        <li class="nav-item" v-for="menu in menuList" :key="menu.code" @click="close()">
          <router-link :to="menu.path" :class="['nav-link', {'active': menu.code === currentTab }]">{{ menu.name }}</router-link>
        </li>
        <li class="nav-item" @click="close()">
          <a href="/" target="_blank" class="nav-link">비즈해줌</a>
        </li>
        <li class="nav-item" @click="close()">
          <a href="#" class="nav-link f-w-normal" @click.prevent="$emit('logout')">로그아웃</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'mobile-gnb',
    props: {
      currentTab: {
        type: String,
        default () {
          return ''
        }
      },
      menuList: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        menuActive: false
      }
    },
    watch: {
      'menuActive': {
        handler (val) {
          this.$emit('setOverlay', val)
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    methods: {
      close () {
        // 활성화된 메뉴창을 닫는다.
        const el = this.$el
        const mobileNav = el.querySelector('#mobileNav')

        if (mobileNav) {
          $(mobileNav).collapse('hide')
        }
      }
    },
    mounted () {
      const el = this.$el
      const mobileNav = $(el.querySelector('#mobileNav'))

      // mobile GNB collapse show event listener
      mobileNav.on('show.bs.collapse', () => {
        this.menuActive = true
      })

      // mobile GNB collapse hide event listener
      mobileNav.on('hide.bs.collapse', () => {
        this.menuActive = false
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/components/mobile_gnb';
  .navbar-brand {
    max-width: 197px;
    padding: 24px 16px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminMobileGnb.vue